import { ColorSystemNegative1, Spacing8 } from 'autogen/design-tokens/tokens';
import {
    ActivateEmployeeLogin,
    type ActivateEmployeeLoginSuccess,
    type PersonalOfferListItemPinCodeTexts
} from 'autogen/swagger/all';
import { Button } from 'components/Button';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon';
import { TextInput } from 'components/shared/inputs/text';
import type React from 'react';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoint } from 'variables';

const PinCodeWrapper = styled.div`
    display: grid;
    gap: ${Spacing8};

    ${breakpoint.up(400)} {
        grid-template-columns: 1fr auto;
    }
`;

const ValidationMessage = styled(Typography.Body)<Pick<ActivateEmployeeLoginSuccess, 'success'>>`
    margin-bottom: 0;

    ${({ success }) =>
        !success &&
        css`
            color: ${ColorSystemNegative1};
        `}
`;

interface IPinCode extends PersonalOfferListItemPinCodeTexts {
    onSubmitCallback: (success: boolean) => void;
}

export default function PinCode({ placeholder, submit, onSubmitCallback, ...restProps }: IPinCode): JSX.Element {
    const [inputType, setInputType] = useState<React.HTMLInputTypeAttribute>('password');
    const [inputValue, setInputValue] = useState<string>();
    const [validation, setValidation] = useState<ActivateEmployeeLoginSuccess>();

    function handleSubmit() {
        ActivateEmployeeLogin({ pinCode: inputValue }).then((res) => {
            setValidation(res);
            onSubmitCallback(res.success);
        });
    }

    function VisibilityIcon(): JSX.Element | null {
        switch (inputType) {
            case 'password':
                return <Icon type="Visibility" size={16} onClick={() => setInputType('text')} />;
            case 'text':
                return <Icon type="VisibilityOff" size={16} onClick={() => setInputType('password')} />;
            default:
                return null;
        }
    }

    return (
        <PinCodeWrapper {...restProps}>
            <TextInput
                isInvalid={validation?.success === false}
                type={inputType}
                placeholder={placeholder}
                rightIcon={<Icon type="Visibility" size={16} />}
                onChange={(event) => setInputValue(event.target.value)}
            />
            <Button variant="primary" size="md" onClick={handleSubmit}>
                {submit}
            </Button>
            {validation?.message && (
                <ValidationMessage size="S" success={validation.success}>
                    {validation.message}
                </ValidationMessage>
            )}
        </PinCodeWrapper>
    );
}
